// @flow

// Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import {
  // actions
  fetchRecommendationById,
  // Selectors
  recommendations$,
} from 'hfty-recommendations'

// Types
import type {
  Recommendation,
} from 'hfty-model-recommendations/types'

type MapDispatchToProps = {
  actions: {
    fetchRecommendationById: Function,
  }
}

type MapStateToProps = {
  recommendations: Array<Recommendation>,
}

const mapStateToProps = function (state: Object): MapStateToProps {
  return {
    recommendations: recommendations$(state),
  }
}

function mapDispatchToProps (dispatch: Dispatch<*>): MapDispatchToProps {
  return {
    actions: bindActionCreators({
      fetchRecommendationById: fetchRecommendationById,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)
